
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BookmarkPlus } from 'lucide-react';

interface EmptyMyTechniquesProps {
  searchQuery: string;
}

export const EmptyMyTechniques: React.FC<EmptyMyTechniquesProps> = ({ searchQuery }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="bg-primary/10 p-3 rounded-full mb-4">
        <BookmarkPlus className="h-6 w-6 text-primary" />
      </div>
      <h3 className="text-lg font-medium mb-2">No saved techniques</h3>
      <p className="text-muted-foreground max-w-md mb-4">
        {searchQuery ? 
          "No techniques match your search. Try a different search term." : 
          "You haven't saved any techniques yet. Start building your collection from the technique library."}
      </p>
      <Button asChild>
        <Link to="/techniques">Browse Technique Library</Link>
      </Button>
    </div>
  );
};
